function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import Vue from "vue";

function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(e, t) {
  for (var n, o = 0; o < t.length; o++) {
    n = t[o], n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}

function _createClass(e, t, i) {
  return t && _defineProperties(e.prototype, t), i && _defineProperties(e, i), e;
}

function _defineProperty(e, t, i) {
  return t in e ? Object.defineProperty(e, t, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = i, e;
}

function _objectSpread(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null == arguments[t] ? {} : arguments[t],
        o = Object.keys(n);
    "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
      return Object.getOwnPropertyDescriptor(n, e).enumerable;
    }))), o.forEach(function (t) {
      _defineProperty(e, t, n[t]);
    });
  }

  return e;
}

function _toConsumableArray(e) {
  return _arrayWithoutHoles(e) || _iterableToArray(e) || _nonIterableSpread();
}

function _arrayWithoutHoles(e) {
  if (Array.isArray(e)) {
    for (var t = 0, n = Array(e.length); t < e.length; t++) {
      n[t] = e[t];
    }

    return n;
  }
}

function _iterableToArray(e) {
  if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function createCommonjsModule(e, t) {
  return t = {
    exports: {}
  }, e(t, t.exports), t.exports;
}

var _classnames = createCommonjsModule(function (e) {
  /*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
  */

  /* global define */
  (function () {
    function t() {
      for (var e, n = [], o = 0; o < arguments.length; o++) {
        if (e = arguments[o], e) {
          var a = _typeof(e);

          if ("string" === a || "number" === a) n.push(e);else if (Array.isArray(e) && e.length) {
            var s = t.apply(null, e);
            s && n.push(s);
          } else if ("object" === a) for (var r in e) {
            i.call(e, r) && e[r] && n.push(r);
          }
        }
      }

      return n.join(" ");
    }

    var i = {}.hasOwnProperty;
    e.exports ? (t["default"] = t, e.exports = t) : window.classNames = t;
  })();
}),
    easyBem = function easyBem(e) {
  return function (t, i) {
    if (!t) return e;
    var n;
    "string" == typeof t ? n = t : i = t;
    var o = e;
    return n && (o += "__" + n), o + (i ? Object.keys(i).reduce(function (e, t) {
      var n = i[t];
      return n && (e += " " + ("boolean" == typeof n ? o + "--" + t : o + "--" + t + "_" + n)), e;
    }, "") : "");
  };
};
/**
* BEM class name factory.
*
* @typedef {Function} Bem
* @param {String|Object} [elementOrMods] Element name or hash object with mods
* @param {Object} [mods] Hash object with mods
* @returns {String}
*/

/**
* Returns BEM class name factory.
*
* @param {String} componentName Block name
* @returns {Bem}
*/

/**
* Returns a function, that, as long as it continues to be invoked, will not
* be triggered. The function will be called after it stops being called for
* N milliseconds. If `immediate` is passed, trigger the function on the
* leading edge, instead of the trailing. The function also has a property 'clear' 
* that is a function which will clear the timer to prevent previously scheduled executions. 
*
* @source underscore.js
* @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
* @param {Function} function to wrap
* @param {Number} timeout in ms (`100`)
* @param {Boolean} whether to execute at the beginning (`false`)
* @api public
*/


function debounce(e, t, i) {
  function n() {
    var l = Date.now() - r;
    l < t && 0 <= l ? o = setTimeout(n, t - l) : (o = null, !i && (c = e.apply(s, a), s = a = null));
  }

  var o, a, s, r, c;
  null == t && (t = 100);

  var l = function l() {
    s = this, a = arguments, r = Date.now();
    var l = i && !o;
    return o || (o = setTimeout(n, t)), l && (c = e.apply(s, a), s = a = null), c;
  };

  return l.clear = function () {
    o && (clearTimeout(o), o = null);
  }, l.flush = function () {
    o && (c = e.apply(s, a), s = a = null, clearTimeout(o), o = null);
  }, l;
} // Adds compatibility for ES modules


debounce.debounce = debounce;
var debounce_1 = debounce;

function directionNames(e, t) {
  var i, n;
  return e && t ? (i = "".concat(e).concat(t[0].toUpperCase()).concat(t.slice(1)), n = "".concat(e, "-").concat(t)) : (i = e || t, n = e || t), {
    name: i,
    classname: n
  };
}

function isLocal(e) {
  return /^data:/.test(e) || /^blob:/.test(e);
}

function isCrossOriginURL(e) {
  if (isLocal(e)) return !1;

  var t = window.location,
      i = /(\w+:)?(?:\/\/)([\w.-]+)?(?::(\d+))?\/?/,
      n = i.exec(e) || [],
      o = {
    protocol: n[1] || "",
    host: n[2] || "",
    port: n[3] || ""
  },
      a = function a(e) {
    return {
      "http:": 80,
      "https:": 443
    }[e];
  },
      s = function s(e) {
    return e.port || a(e.protocol || t.protocol);
  };

  return (o.protocol || o.host || o.port) && !!!(o.protocol && o.protocol == t.protocol && o.host && o.host == t.host && o.host && s(o) == s(t));
}

function addTimestamp(e) {
  var t = "timestamp=".concat(new Date().getTime());
  return e + (-1 === e.indexOf("?") ? "?" : "&") + t;
}

var ResizeEvent = function e(t, i, n) {
  _classCallCheck(this, e), this.nativeEvent = t, this.directions = i, this.params = n;
},
    MoveEvent = function e(t, i) {
  _classCallCheck(this, e), this.nativeEvent = t, this.directions = i;
},
    DragEvent = /*#__PURE__*/function () {
  function e(t, i, n, o, a) {
    _classCallCheck(this, e), this.nativeEvent = t, this.position = n, this.previousPosition = o, this.element = i, this.anchor = a;
  }

  return _createClass(e, [{
    key: "shift",
    value: function value() {
      var e = this.element,
          t = this.anchor,
          i = this.position,
          n = e.getBoundingClientRect(),
          o = n.left,
          a = n.top;
      return {
        left: i.left - o - t.left,
        top: i.top - a - t.top
      };
    }
  }]), e;
}(),
    draggable = {
  beforeMount: function beforeMount() {
    window.addEventListener("mouseup", this.onMouseUp, {
      passive: !1
    }), window.addEventListener("mousemove", this.onMouseMove, {
      passive: !1
    }), window.addEventListener("touchmove", this.onTouchMove, {
      passive: !1
    }), window.addEventListener("touchend", this.onTouchEnd, {
      passive: !1
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
  },
  mounted: function mounted() {
    if (!this.$refs.draggable) throw new Error("You should add ref \"draggable\" to your root element to use draggable mixin");
    this.touches = [], this.draggingAnchor = [], this.hovered = !1;
  },
  methods: {
    onMouseOver: function onMouseOver() {
      this.hovered || (this.hovered = !0, this.$emit("enter"));
    },
    onMouseLeave: function onMouseLeave() {
      this.hovered && (this.hovered = !1, this.$emit("leave"));
    },
    onTouchStart: function onTouchStart(t) {
      t.cancelable && (this.touches = _toConsumableArray(t.touches), !this.hovered && this.$emit("enter"), t.touches.length && this.initAnchor(this.touches.reduce(function (e, i) {
        return {
          clientX: e.clientX + i.clientX / t.touches.length,
          clientY: e.clientY + i.clientY / t.touches.length
        };
      }, {
        clientX: 0,
        clientY: 0
      })), t.preventDefault && t.preventDefault(), t.stopPropagation());
    },
    onTouchEnd: function onTouchEnd() {
      this.processEnd();
    },
    onTouchMove: function onTouchMove(t) {
      this.touches.length && (this.processMove(t, t.touches), t.preventDefault && t.preventDefault(), t.stopPropagation && t.stopPropagation());
    },
    onMouseDown: function onMouseDown(t) {
      var e = {
        fake: !0,
        clientX: t.clientX,
        clientY: t.clientY
      };
      this.touches = [e], this.initAnchor(e), t.stopPropagation();
    },
    onMouseMove: function onMouseMove(t) {
      this.touches.length && (this.processMove(t, [{
        fake: !0,
        clientX: t.clientX,
        clientY: t.clientY
      }]), t.preventDefault && t.preventDefault());
    },
    onMouseUp: function onMouseUp() {
      this.touches = [];
    },
    initAnchor: function initAnchor(e) {
      var t = this.$refs.draggable,
          i = t.getBoundingClientRect(),
          n = i.left,
          o = i.right,
          a = i.bottom,
          s = i.top;
      this.anchor = {
        left: e.clientX - n,
        top: e.clientY - s,
        bottom: a - e.clientY,
        right: o - e.clientX
      };
    },
    processMove: function processMove(e, t) {
      var i = _toConsumableArray(t);

      if (this.touches.length) {
        if (1 === this.touches.length && 1 === i.length) {
          var n = this.$refs.draggable;
          this.$emit("drag", new DragEvent(e, n, {
            left: i[0].clientX,
            top: i[0].clientY
          }, {
            left: this.touches[0].clientX,
            top: this.touches[0].clientY
          }, this.anchor));
        }

        this.touches = i;
      }
    },
    processEnd: function processEnd() {
      this.touches = [], this.hovered && (this.$emit("leave"), this.hovered = !1);
    }
  }
},
    script = {
  name: "DraggableElement",
  mixins: [draggable],
  props: {
    classname: {
      type: String
    }
  }
};
/* script */


var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var e = this,
      t = e.$createElement,
      i = e._self._c || t;
  return i("div", {
    ref: "draggable",
    "class": e.classname,
    on: {
      touchstart: e.onTouchStart,
      mousedown: e.onMouseDown,
      mouseover: e.onMouseOver,
      mouseleave: e.onMouseLeave
    }
  }, [e._t("default")], 2);
},
    __vue_staticRenderFns__ = [];

__vue_render__._withStripped = !0;
/* style */

var __vue_inject_styles__ = void 0,
    __vue_scope_id__ = void 0,
    __vue_module_identifier__ = void 0,
    __vue_is_functional_template__ = !1;
/* scoped */

/* component normalizer */


function __vue_normalize__(e, t, i, n, o) {
  var a = ("function" == typeof i ? i.options : i) || {}; // For security concerns, we use only base name in production mode.

  return a.__file = "C:\\Live\\Projects\\Hot\\Vue Cropper\\vue-advanced-cropper-rollup\\src\\components\\service\\DraggableElement.vue", a.render || (a.render = e.render, a.staticRenderFns = e.staticRenderFns, a._compiled = !0, o && (a.functional = !0)), a._scopeId = n, a;
}
/* style inject */

/* style inject SSR */


var DraggableElement = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, void 0, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, void 0, void 0),
    cn = easyBem("vue-handler-wrapper"),
    script$1 = {
  name: "HandlerWrapper",
  components: {
    DraggableElement: DraggableElement
  },
  props: {
    horizontalPosition: {
      type: String
    },
    verticalPosition: {
      type: String
    },
    classname: {
      type: String
    }
  },
  computed: {
    classnames: function classnames() {
      var e;

      if (this.horizontalPosition || this.verticalPosition) {
        var t = directionNames(this.horizontalPosition, this.verticalPosition);
        e = _classnames(this.classname, cn(_defineProperty({}, t.classname, !0)));
      } else e = _classnames(this.classname, cn());

      return {
        "default": e,
        draggable: cn("draggable")
      };
    }
  }
};
/* script */


var __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function __vue_render__$1() {
  var e = this,
      t = e.$createElement,
      i = e._self._c || t;
  return i("div", {
    "class": e.classnames["default"]
  }, [i("DraggableElement", {
    "class": e.classnames.draggable,
    on: {
      drag: function drag(t) {
        return e.$emit("drag", t);
      },
      leave: function leave() {
        return e.$emit("leave");
      },
      enter: function enter() {
        return e.$emit("enter");
      }
    }
  }, [e._t("default")], 2)], 1);
},
    __vue_staticRenderFns__$1 = [];

__vue_render__$1._withStripped = !0;
/* style */

var __vue_inject_styles__$1 = void 0,
    __vue_scope_id__$1 = void 0,
    __vue_module_identifier__$1 = void 0,
    __vue_is_functional_template__$1 = !1;
/* scoped */

/* component normalizer */


function __vue_normalize__$1(e, t, i, n, o) {
  var a = ("function" == typeof i ? i.options : i) || {}; // For security concerns, we use only base name in production mode.

  return a.__file = "C:\\Live\\Projects\\Hot\\Vue Cropper\\vue-advanced-cropper-rollup\\src\\components\\service\\HandlerWrapper.vue", a.render || (a.render = e.render, a.staticRenderFns = e.staticRenderFns, a._compiled = !0, o && (a.functional = !0)), a._scopeId = n, a;
}
/* style inject */

/* style inject SSR */


var HandlerWrapper = __vue_normalize__$1({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, void 0, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, void 0, void 0),
    cn$1 = easyBem("vue-line-wrapper"),
    script$2 = {
  name: "LineWrapper",
  components: {
    DraggableElement: DraggableElement
  },
  props: {
    position: {
      type: String,
      required: !0
    }
  },
  computed: {
    classname: function classname() {
      return cn$1(_defineProperty({}, this.position, !0));
    }
  }
};
/* script */


var __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function __vue_render__$2() {
  var e = this,
      t = e.$createElement,
      i = e._self._c || t;
  return i("DraggableElement", {
    "class": e.classname,
    on: {
      drag: function drag(t) {
        return e.$emit("drag", t);
      },
      leave: function leave() {
        return e.$emit("leave");
      },
      enter: function enter() {
        return e.$emit("enter");
      }
    }
  }, [e._t("default")], 2);
},
    __vue_staticRenderFns__$2 = [];

__vue_render__$2._withStripped = !0;
/* style */

var __vue_inject_styles__$2 = void 0,
    __vue_scope_id__$2 = void 0,
    __vue_module_identifier__$2 = void 0,
    __vue_is_functional_template__$2 = !1;
/* scoped */

/* component normalizer */


function __vue_normalize__$2(e, t, i, n, o) {
  var a = ("function" == typeof i ? i.options : i) || {}; // For security concerns, we use only base name in production mode.

  return a.__file = "C:\\Live\\Projects\\Hot\\Vue Cropper\\vue-advanced-cropper-rollup\\src\\components\\service\\LineWrapper.vue", a.render || (a.render = e.render, a.staticRenderFns = e.staticRenderFns, a._compiled = !0, o && (a.functional = !0)), a._scopeId = n, a;
}
/* style inject */

/* style inject SSR */


var LineWrapper = __vue_normalize__$2({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, void 0, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, void 0, void 0),
    cn$2 = easyBem("vue-bounding-box"),
    HORIZONTAL_DIRECTIONS = ["east", "west", null],
    VERTICAL_DIRECTIONS = ["south", "north", null],
    script$3 = {
  name: "BoundingBox",
  props: {
    classname: {
      type: String
    },
    handlers: {
      type: Object,
      "default": function _default() {
        return {
          eastNorth: !0,
          north: !0,
          westNorth: !0,
          west: !0,
          westSouth: !0,
          south: !0,
          eastSouth: !0,
          east: !0
        };
      }
    },
    handlerComponent: {
      type: [Object, String]
    },
    handlersClassnames: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    lines: {
      type: Object,
      "default": function _default() {
        return {
          west: !0,
          north: !0,
          east: !0,
          south: !0
        };
      }
    },
    lineComponent: {
      type: [Object, String]
    },
    linesClassnames: {
      type: Object,
      "default": function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var e = [];
    return HORIZONTAL_DIRECTIONS.forEach(function (t) {
      VERTICAL_DIRECTIONS.forEach(function (i) {
        if (t !== i) {
          var n = directionNames(t, i),
              o = n.name,
              a = n.classname;
          e.push({
            name: o,
            classname: a,
            verticalDirection: i,
            horizontalDirection: t
          });
        }
      });
    }), {
      points: e
    };
  },
  computed: {
    classnames: function classnames() {
      var e = this.handlersClassnames,
          t = this.linesClassnames;
      return {
        "default": _classnames(cn$2(), this.classname),
        handlers: e,
        lines: t
      };
    },
    lineNodes: function lineNodes() {
      var e = this,
          t = [];
      return this.points.forEach(function (i) {
        i.horizontalDirection && i.verticalDirection || !e.lines[i.name] || t.push({
          name: i.name,
          component: e.lineComponent,
          classname: _classnames(e.classnames.lines["default"], e.classnames.lines[i.name]),
          hoverClassname: e.classnames.lines.hover,
          verticalDirection: i.verticalDirection,
          horizontalDirection: i.horizontalDirection
        });
      }), t;
    },
    handlerNodes: function handlerNodes() {
      var e = this,
          t = [];
      return this.points.forEach(function (i) {
        e.handlers[i.name] && t.push({
          name: i.name,
          component: e.handlerComponent,
          classname: _classnames(e.classnames.handlers["default"], e.classnames.handlers[i.name]),
          hoverClassname: e.classnames.handlers.hover,
          verticalDirection: i.verticalDirection,
          horizontalDirection: i.horizontalDirection
        });
      }), t;
    }
  },
  beforeMount: function beforeMount() {
    window.addEventListener("mouseup", this.onMouseUp, {
      passive: !1
    }), window.addEventListener("mousemove", this.onMouseMove, {
      passive: !1
    }), window.addEventListener("touchmove", this.onTouchMove, {
      passive: !1
    }), window.addEventListener("touchend", this.onTouchEnd, {
      passive: !1
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
  },
  mounted: function mounted() {
    this.touches = [], this.draggingAnchor = [];
  },
  methods: {
    onHandlerDrag: function onHandlerDrag(e, t, i) {
      var n = e.shift(),
          o = n.left,
          a = n.top,
          s = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
      };
      "west" === t ? s.left -= o : "east" == t && (s.right += o), "north" === i ? s.top -= a : "south" == i && (s.bottom += a);
      var r;
      !i && t ? r = "width" : i && !t && (r = "height"), this.$emit("resize", new ResizeEvent(e.nativeEvent, s, {
        allowedDirections: {
          left: "west" === t || !t,
          right: "east" === t || !t,
          bottom: "south" === i || !i,
          top: "north" === i || !i
        },
        preserveAspectRatio: e.nativeEvent.shiftKey,
        respectDirection: r
      }));
    }
  }
};
/* script */


var __vue_script__$3 = script$3;
/* template */

var __vue_render__$3 = function __vue_render__$3() {
  var e = this,
      t = e.$createElement,
      i = e._self._c || t;
  return i("div", {
    ref: "box",
    "class": e.classnames["default"]
  }, [e._t("default"), e._v(" "), i("div", e._l(e.lineNodes, function (t) {
    return i(t.component, {
      key: t.name,
      tag: "component",
      attrs: {
        classname: t.classname,
        "hover-classname": t.hoverClassname,
        position: t.name
      },
      on: {
        drag: function drag(i) {
          return e.onHandlerDrag(i, t.horizontalDirection, t.verticalDirection);
        }
      }
    });
  }), 1), e._v(" "), i("div", e._l(e.handlerNodes, function (t) {
    return i(t.component, {
      key: t.name,
      tag: "component",
      attrs: {
        classname: t.classname,
        "hover-classname": t.hoverClassname,
        "horizontal-position": t.horizontalDirection,
        "vertical-position": t.verticalDirection
      },
      on: {
        drag: function drag(i) {
          return e.onHandlerDrag(i, t.horizontalDirection, t.verticalDirection);
        }
      }
    });
  }), 1)], 2);
},
    __vue_staticRenderFns__$3 = [];

__vue_render__$3._withStripped = !0;
/* style */

var __vue_inject_styles__$3 = void 0,
    __vue_scope_id__$3 = void 0,
    __vue_module_identifier__$3 = void 0,
    __vue_is_functional_template__$3 = !1;
/* scoped */

/* component normalizer */


function __vue_normalize__$3(e, t, i, n, o) {
  var a = ("function" == typeof i ? i.options : i) || {}; // For security concerns, we use only base name in production mode.

  return a.__file = "C:\\Live\\Projects\\Hot\\Vue Cropper\\vue-advanced-cropper-rollup\\src\\components\\service\\BoundingBox.vue", a.render || (a.render = e.render, a.staticRenderFns = e.staticRenderFns, a._compiled = !0, o && (a.functional = !0)), a._scopeId = n, a;
}
/* style inject */

/* style inject SSR */


var BoundingBox = __vue_normalize__$3({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, void 0, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, void 0, void 0),
    cn$3 = easyBem("vue-draggable-area"),
    script$4 = {
  name: "DraggableArea",
  computed: {
    classnames: function classnames() {
      return {
        "default": _classnames(cn$3(), this.classname)
      };
    }
  },
  beforeMount: function beforeMount() {
    window.addEventListener("mouseup", this.onMouseUp, {
      passive: !1
    }), window.addEventListener("mousemove", this.onMouseMove, {
      passive: !1
    }), window.addEventListener("touchmove", this.onTouchMove, {
      passive: !1
    }), window.addEventListener("touchend", this.onTouchEnd, {
      passive: !1
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
  },
  mounted: function mounted() {
    this.touches = [], this.draggingAnchor = [];
  },
  methods: {
    onTouchStart: function onTouchStart(t) {
      t.cancelable && (this.touches = _toConsumableArray(t.touches), t.touches.length && this.initAnchor(this.touches.reduce(function (e, i) {
        return {
          clientX: e.clientX + i.clientX / t.touches.length,
          clientY: e.clientY + i.clientY / t.touches.length
        };
      }, {
        clientX: 0,
        clientY: 0
      })), t.preventDefault && t.preventDefault(), t.stopPropagation());
    },
    onTouchEnd: function onTouchEnd() {
      this.processEnd();
    },
    onTouchMove: function onTouchMove(t) {
      this.touches.length && (this.processMove(t, t.touches), t.preventDefault && t.preventDefault(), t.stopPropagation && t.stopPropagation());
    },
    onMouseDown: function onMouseDown(t) {
      var e = {
        fake: !0,
        clientX: t.clientX,
        clientY: t.clientY
      };
      this.touches = [e], this.initAnchor(e), t.stopPropagation();
    },
    onMouseMove: function onMouseMove(t) {
      this.touches.length && (this.processMove(t, [{
        fake: !0,
        clientX: t.clientX,
        clientY: t.clientY
      }]), t.preventDefault && t.cancelable && t.preventDefault());
    },
    onMouseUp: function onMouseUp() {
      this.touches = [];
    },
    initAnchor: function initAnchor(e) {
      var t = this.$refs.container,
          i = t.getBoundingClientRect(),
          n = i.left,
          o = i.top;
      this.anchor = {
        x: e.clientX - n,
        y: e.clientY - o
      };
    },
    processMove: function processMove(e, t) {
      var i = Math.pow,
          n = this,
          o = _toConsumableArray(t);

      if (this.touches.length) {
        var a = this.$refs.container,
            s = a.getBoundingClientRect(),
            r = s.left,
            c = s.top;
        if (1 === this.touches.length && 1 === o.length) this.$emit("move", new MoveEvent(e, {
          left: o[0].clientX - r - this.anchor.x,
          top: o[0].clientY - c - this.anchor.y
        }));else if (1 < this.touches.length && this.touches.length === o.length) {
          var l = o.map(function (e, t) {
            return {
              x: e.clientX - n.touches[t].clientX,
              y: e.clientY - n.touches[t].clientY,
              position: {
                clientX: e.clientX,
                clientY: e.clientY
              },
              length: Math.sqrt(i(e.clientX - n.touches[t].clientX, 2) + i(e.clientY - n.touches[t].clientY, 2))
            };
          }),
              h = l.reduce(function (e, t) {
            return e + t.length;
          }, 0),
              d = {
            left: l.reduce(function (e, t, i) {
              return e + (1 - t.length / h) * o[i].clientX;
            }, 0),
            top: l.reduce(function (e, t, i) {
              return e + (1 - t.length / h) * o[i].clientY;
            }, 0)
          },
              m = {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
          };
          l.forEach(function (e, t) {
            .25 < e.length / h && (o[t].clientY > d.top ? m.bottom += e.y : m.top -= e.y, o[t].clientX > d.left ? m.right += e.x : m.left -= e.x);
          }), this.$emit("resize", new ResizeEvent(e, m));
        }
        this.touches = o;
      }
    },
    processEnd: function processEnd() {
      this.touches = [];
    }
  }
};
/* script */


var __vue_script__$4 = script$4;
/* template */

var __vue_render__$4 = function __vue_render__$4() {
  var e = this,
      t = e.$createElement,
      i = e._self._c || t;
  return i("div", {
    ref: "container",
    on: {
      touchstart: e.onTouchStart,
      mousedown: e.onMouseDown
    }
  }, [e._t("default")], 2);
},
    __vue_staticRenderFns__$4 = [];

__vue_render__$4._withStripped = !0;
/* style */

var __vue_inject_styles__$4 = void 0,
    __vue_scope_id__$4 = void 0,
    __vue_module_identifier__$4 = void 0,
    __vue_is_functional_template__$4 = !1;
/* scoped */

/* component normalizer */


function __vue_normalize__$4(e, t, i, n, o) {
  var a = ("function" == typeof i ? i.options : i) || {}; // For security concerns, we use only base name in production mode.

  return a.__file = "C:\\Live\\Projects\\Hot\\Vue Cropper\\vue-advanced-cropper-rollup\\src\\components\\service\\DraggableArea.vue", a.render || (a.render = e.render, a.staticRenderFns = e.staticRenderFns, a._compiled = !0, o && (a.functional = !0)), a._scopeId = n, a;
}
/* style inject */

/* style inject SSR */


var DraggableArea = __vue_normalize__$4({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, void 0, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, void 0, void 0),
    HORIZONTAL_DIRECTIONS$1 = ["left", "right"],
    VERTICAL_DIRECTIONS$1 = ["top", "bottom"],
    ALL_DIRECTIONS = ["left", "right", "top", "bottom"],
    XHR_DONE = 4;

function prepareSource(e, t, i) {
  var n = Math.PI,
      o = i.flipped,
      a = i.orientation,
      s = t.naturalWidth,
      r = t.naturalHeight,
      c = e.getContext("2d");
  return e.width = s, e.height = r, c.save(), o && (e.width = r, e.height = s), 2 == a ? (c.translate(s, 0), c.scale(-1, 1)) : 3 == a ? (c.translate(s, r), c.rotate(1 * n)) : 4 == a ? (c.translate(0, r), c.scale(1, -1)) : 5 == a ? (c.rotate(90 / 180 * n), c.scale(1, -1)) : 6 == a ? (c.rotate(90 / 180 * n), c.translate(0, -r)) : 7 == a ? (c.rotate(270 / 180 * n), c.translate(-s, r), c.scale(1, -1)) : 8 == a && (c.translate(0, s), c.rotate(270 / 180 * n)), c.drawImage(t, 0, 0, s, r), c.restore(), e;
}

function getImageTransforms(e) {
  var t = {
    orientation: e
  };
  return e && (2 === e ? t.scaleX = -1 : 3 === e ? t.rotate = -180 : 4 === e ? t.scaleY = -1 : 5 === e ? (t.rotate = 90, t.scaleY = -1) : 6 === e ? t.rotate = 90 : 7 === e ? (t.rotate = 90, t.scaleX = -1) : 8 === e ? t.rotate = -90 : void 0), (90 === t.rotate || -90 === t.rotate) && (t.flipped = !0), t;
}

function getStyleTransforms(e) {
  var t = e.rotate,
      i = e.scaleX,
      n = e.scaleY,
      o = "";
  return (t || i || n) && (t && (o += " rotate(".concat(t, "deg) ")), i && (o += " scaleX(".concat(i, ") ")), n && (o += " scaleY(".concat(n, ") "))), o;
}

function parseImage(e) {
  return new Promise(function (t) {
    getImageData(e).then(function (e) {
      t(e ? {
        arrayBuffer: e,
        orientation: getOrientation(e)
      } : {
        arrayBuffer: null,
        orientation: null
      });
    })["catch"](function (e) {
      console.warn(e), t({
        arrayBuffer: null,
        orientation: null
      });
    });
  });
}

function getImageData(e) {
  return new Promise(function (t, i) {
    try {
      if (!e) i("Error: the image is empty");else // Data URL
        if (/^data:/i.test(e)) t(base64ToArrayBuffer(e));else if (/^blob:/i.test(e)) {
          var n = new FileReader();
          n.onload = function (i) {
            t(i.target.result);
          }, objectURLToBlob(e, function (e) {
            n.readAsArrayBuffer(e);
          });
        } else {
          var o = new XMLHttpRequest();
          o.onreadystatechange = function () {
            this.readyState !== XHR_DONE || (200 === this.status || 0 === this.status ? t(this.response) : i("Warning: could not load an image to parse its orientation"), o = null);
          }, o.onprogress = function () {
            "image/jpeg" !== o.getResponseHeader("content-type") && o.abort();
          }, o.withCredentials = !1, o.open("GET", e, !0), o.responseType = "arraybuffer", o.send(null);
        }
    } catch (t) {
      i(t);
    }
  });
}

function objectURLToBlob(e, t) {
  var i = new XMLHttpRequest();
  i.open("GET", e, !0), i.responseType = "blob", i.onload = function () {
    (200 == this.status || 0 === this.status) && t(this.response);
  }, i.send();
}

function base64ToArrayBuffer(e) {
  e = e.replace(/^data:([^;]+);base64,/gmi, "");

  for (var t = atob(e), n = t.length, o = new ArrayBuffer(n), a = new Uint8Array(o), s = 0; s < n; s++) {
    a[s] = t.charCodeAt(s);
  }

  return o;
}

function getStringFromCharCode(e, t, n) {
  var o,
      a = "";

  for (o = t, n += t; o < n; o++) {
    a += String.fromCharCode(e.getUint8(o));
  }

  return a;
}

function getOrientation(e) {
  try {
    var t,
        n,
        o,
        a,
        s,
        r,
        c = new DataView(e); // Only handle JPEG image (start by 0xFFD8)

    if (255 === c.getUint8(0) && 216 === c.getUint8(1)) for (var l = c.byteLength, h = 2; h + 1 < l;) {
      if (255 === c.getUint8(h) && 225 === c.getUint8(h + 1)) {
        s = h;
        break;
      }

      h++;
    }

    if (s && (n = s + 4, o = s + 10, "Exif" === getStringFromCharCode(c, n, 4))) {
      var d = c.getUint16(o);

      if (a = 18761 === d, (a || 19789 === d) && 42 === c.getUint16(o + 2, a)
      /* bigEndian */
      ) {
          var m = c.getUint32(o + 4, a);
          8 <= m && (r = o + m);
        }
    }

    if (r) for (var p, g = c.getUint16(r, a), u = 0; u < g; u++) {
      if (p = r + 12 * u + 2, 274 === c.getUint16(p, a)
      /* Orientation */
      ) {
          p += 8, t = c.getUint16(p, a), c.setUint16(p, 1, a);
          break;
        }
    }
    return t;
  } catch (e) {
    return null;
  }
}

function arrayBufferToDataURL(e) {
  for (var t = [], i = 8192, n = new Uint8Array(e) // Chunk Typed Array for better performance (#435)
  ; 0 < n.length;) {
    var o = n.subarray(0, i);
    t.push(String.fromCharCode.apply(null, Array.from ? Array.from(o) : Array.slice(o))), n = n.subarray(i);
  }

  return "data:image/jpeg;base64,".concat(btoa(t.join("")));
}

var cn$4 = easyBem("vue-preview-result"),
    script$5 = {
  name: "PreviewResult",
  props: {
    img: {
      type: Object
    },
    classname: {
      type: String
    },
    imageClassname: {
      type: String
    },
    resultCoordinates: {
      type: Object,
      "default": function _default() {
        return {
          width: 0,
          height: 0,
          left: 0,
          top: 0
        };
      }
    },
    stencilCoordinates: {
      type: Object,
      "default": function _default() {
        return {
          width: 0,
          height: 0,
          left: 0,
          top: 0
        };
      }
    }
  },
  computed: {
    classnames: function classnames() {
      return {
        "default": _classnames(cn$4(), this.classname),
        image: _classnames(cn$4("image"), this.imageClassname),
        wrapper: cn$4("wrapper")
      };
    },
    wrapperStyle: function wrapperStyle() {
      return {
        width: "".concat(this.stencilCoordinates.width, "px"),
        height: "".concat(this.stencilCoordinates.height, "px"),
        left: "calc(50% - ".concat(this.stencilCoordinates.width / 2, "px)"),
        top: "calc(50% - ".concat(this.stencilCoordinates.height / 2, "px)")
      };
    },
    imageStyle: function imageStyle() {
      var e = this.img.transforms,
          t = this.img.size.width,
          i = this.img.size.height,
          n = this.stencilCoordinates.height / this.resultCoordinates.height,
          o = i * n,
          a = t * n,
          s = e.flipped,
          r = {
        width: "".concat(a, "px"),
        height: "".concat(o, "px")
      };
      return s ? (r.width = "".concat(o, "px"), r.height = "".concat(a, "px"), r.left = "".concat(-this.stencilCoordinates.left - (o - a) / 2, "px"), r.top = "".concat(-this.stencilCoordinates.top - (a - o) / 2, "px")) : (r.width = "".concat(a, "px"), r.height = "".concat(o, "px"), r.left = "".concat(-this.stencilCoordinates.left, "px"), r.top = "".concat(-this.stencilCoordinates.top, "px")), r.transform = getStyleTransforms(e), r;
    }
  }
};
/* script */

var __vue_script__$5 = script$5;
/* template */

var __vue_render__$5 = function __vue_render__$5() {
  var e = this,
      t = e.$createElement,
      i = e._self._c || t;
  return i("div", {
    "class": e.classnames["default"]
  }, [i("div", {
    ref: "wrapper",
    "class": e.classnames.wrapper,
    style: e.wrapperStyle
  }, [i("img", {
    ref: "image",
    "class": e.classnames.image,
    style: e.imageStyle,
    attrs: {
      src: e.img.src
    }
  })])]);
},
    __vue_staticRenderFns__$5 = [];

__vue_render__$5._withStripped = !0;
/* style */

var __vue_inject_styles__$5 = void 0,
    __vue_scope_id__$5 = void 0,
    __vue_module_identifier__$5 = void 0,
    __vue_is_functional_template__$5 = !1;
/* scoped */

/* component normalizer */


function __vue_normalize__$5(e, t, i, n, o) {
  var a = ("function" == typeof i ? i.options : i) || {}; // For security concerns, we use only base name in production mode.

  return a.__file = "C:\\Live\\Projects\\Hot\\Vue Cropper\\vue-advanced-cropper-rollup\\src\\components\\service\\PreviewResult.vue", a.render || (a.render = e.render, a.staticRenderFns = e.staticRenderFns, a._compiled = !0, o && (a.functional = !0)), a._scopeId = n, a;
}
/* style inject */

/* style inject SSR */


var PreviewResult = __vue_normalize__$5({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, void 0, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, void 0, void 0),
    cn$5 = easyBem("vue-square-handler"),
    script$6 = {
  name: "SimpleHandler",
  components: {
    HandlerWrapper: HandlerWrapper
  },
  props: {
    classname: {
      type: String
    },
    hoverClassname: {
      type: String
    },
    horizontalPosition: {
      type: String
    },
    verticalPosition: {
      type: String
    }
  },
  computed: {
    classnames: function classnames() {
      return {
        "default": _classnames(cn$5(_defineProperty({}, this.position, !0)), this.classname, this.hover && this.hoverClassname)
      };
    }
  },
  methods: {
    onDrag: function onDrag(e) {
      this.$emit("drag", e);
    },
    onEnter: function onEnter() {
      this.hover = !0;
    },
    onLeave: function onLeave() {
      this.hover = !1;
    }
  }
};
/* script */


var __vue_script__$6 = script$6;
/* template */

var __vue_render__$6 = function __vue_render__$6() {
  var e = this,
      t = e.$createElement,
      i = e._self._c || t;
  return i("HandlerWrapper", {
    attrs: {
      "vertical-position": e.verticalPosition,
      "horizontal-position": e.horizontalPosition
    },
    on: {
      drag: e.onDrag
    }
  }, [i("div", {
    "class": e.classnames["default"]
  })]);
},
    __vue_staticRenderFns__$6 = [];

__vue_render__$6._withStripped = !0;
/* style */

var __vue_inject_styles__$6 = void 0,
    __vue_scope_id__$6 = void 0,
    __vue_module_identifier__$6 = void 0,
    __vue_is_functional_template__$6 = !1;
/* scoped */

/* component normalizer */


function __vue_normalize__$6(e, t, i, n, o) {
  var a = ("function" == typeof i ? i.options : i) || {}; // For security concerns, we use only base name in production mode.

  return a.__file = "C:\\Live\\Projects\\Hot\\Vue Cropper\\vue-advanced-cropper-rollup\\src\\components\\handlers\\SimpleHandler.vue", a.render || (a.render = e.render, a.staticRenderFns = e.staticRenderFns, a._compiled = !0, o && (a.functional = !0)), a._scopeId = n, a;
}
/* style inject */

/* style inject SSR */


var SimpleHandler = __vue_normalize__$6({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, void 0, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, void 0, void 0),
    cn$6 = easyBem("vue-simple-line"),
    script$7 = {
  name: "SimpleLine",
  components: {
    LineWrapper: LineWrapper
  },
  props: {
    classname: {
      type: String
    },
    hoverClassname: {
      type: String
    },
    position: {
      type: String
    }
  },
  data: function data() {
    return {
      hover: !1
    };
  },
  computed: {
    classnames: function classnames() {
      return {
        "default": _classnames(cn$6(_defineProperty({}, this.position, !0)), this.classname, this.hover && this.hoverClassname)
      };
    }
  },
  methods: {
    onDrag: function onDrag(e) {
      this.$emit("drag", e);
    },
    onEnter: function onEnter() {
      this.hover = !0;
    },
    onLeave: function onLeave() {
      this.hover = !1;
    }
  }
};
/* script */


var __vue_script__$7 = script$7;
/* template */

var __vue_render__$7 = function __vue_render__$7() {
  var e = this,
      t = e.$createElement,
      i = e._self._c || t;
  return i("LineWrapper", {
    attrs: {
      position: e.position
    },
    on: {
      enter: e.onEnter,
      leave: e.onLeave,
      drag: e.onDrag
    }
  }, [i("div", {
    "class": e.classnames["default"]
  })]);
},
    __vue_staticRenderFns__$7 = [];

__vue_render__$7._withStripped = !0;
/* style */

var __vue_inject_styles__$7 = void 0,
    __vue_scope_id__$7 = void 0,
    __vue_module_identifier__$7 = void 0,
    __vue_is_functional_template__$7 = !1;
/* scoped */

/* component normalizer */


function __vue_normalize__$7(e, t, i, n, o) {
  var a = ("function" == typeof i ? i.options : i) || {}; // For security concerns, we use only base name in production mode.

  return a.__file = "C:\\Live\\Projects\\Hot\\Vue Cropper\\vue-advanced-cropper-rollup\\src\\components\\lines\\SimpleLine.vue", a.render || (a.render = e.render, a.staticRenderFns = e.staticRenderFns, a._compiled = !0, o && (a.functional = !0)), a._scopeId = n, a;
}
/* style inject */

/* style inject SSR */


var SimpleLine = __vue_normalize__$7({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, void 0, __vue_script__$7, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, void 0, void 0),
    cn$7 = easyBem("vue-rectangle-stencil"),
    script$8 = {
  name: "RectangleStencil",
  components: {
    PreviewResult: PreviewResult,
    BoundingBox: BoundingBox,
    DraggableArea: DraggableArea
  },
  props: {
    img: {
      type: Object
    },
    resultCoordinates: {
      type: Object
    },
    stencilCoordinates: {
      type: Object
    },
    handlers: {
      type: Object
    },
    handlerComponent: {
      type: [Object, String],
      "default": function _default() {
        return SimpleHandler;
      }
    },
    handlersClassnames: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    lines: {
      type: Object
    },
    lineComponent: {
      type: [Object, String],
      "default": function _default() {
        return SimpleLine;
      }
    },
    linesClassnames: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    classname: {
      type: String
    },
    previewClassname: {
      type: String
    },
    boundingBoxClassname: {
      type: String
    },
    aspectRatio: {
      type: [Number, String]
    },
    minAspectRatio: {
      type: [Number, String]
    },
    maxAspectRatio: {
      type: [Number, String]
    }
  },
  computed: {
    classes: function classes() {
      return {
        stencil: _classnames(cn$7(), this.classname),
        preview: _classnames(cn$7("preview"), this.previewClassname),
        boundingBox: _classnames(cn$7("bounding-box"), this.boundingBoxClassname)
      };
    },
    style: function style() {
      var e = this.stencilCoordinates,
          t = e.height,
          i = e.width,
          n = e.left,
          o = e.top;
      return {
        width: "".concat(i, "px"),
        height: "".concat(t, "px"),
        left: "".concat(n, "px"),
        top: "".concat(o, "px")
      };
    }
  },
  methods: {
    onMove: function onMove(e) {
      this.$emit("move", e);
    },
    onResize: function onResize(e) {
      this.$emit("resize", e);
    },
    aspectRatios: function aspectRatios() {
      return {
        minimum: this.aspectRatio || this.minAspectRatio,
        maximum: this.aspectRatio || this.maxAspectRatio
      };
    }
  }
};
/* script */


var __vue_script__$8 = script$8;
/* template */

var __vue_render__$8 = function __vue_render__$8() {
  var e = this,
      t = e.$createElement,
      i = e._self._c || t;
  return i("div", {
    "class": e.classes.stencil,
    style: e.style
  }, [i("BoundingBox", {
    attrs: {
      classname: e.classes.boundingBox,
      handlers: e.handlers,
      "handler-component": e.handlerComponent,
      "handlers-classnames": e.handlersClassnames,
      lines: e.lines,
      "line-component": e.lineComponent,
      "lines-classnames": e.linesClassnames
    },
    on: {
      resize: e.onResize
    }
  }, [i("DraggableArea", {
    on: {
      move: e.onMove
    }
  }, [i("PreviewResult", {
    attrs: {
      img: e.img,
      classname: e.classes.preview,
      "result-coordinates": e.resultCoordinates,
      "stencil-coordinates": e.stencilCoordinates
    }
  })], 1)], 1)], 1);
},
    __vue_staticRenderFns__$8 = [];

__vue_render__$8._withStripped = !0;
/* style */

var __vue_inject_styles__$8 = void 0,
    __vue_scope_id__$8 = void 0,
    __vue_module_identifier__$8 = void 0,
    __vue_is_functional_template__$8 = !1;
/* scoped */

/* component normalizer */


function __vue_normalize__$8(e, t, i, n, o) {
  var a = ("function" == typeof i ? i.options : i) || {}; // For security concerns, we use only base name in production mode.

  return a.__file = "C:\\Live\\Projects\\Hot\\Vue Cropper\\vue-advanced-cropper-rollup\\src\\components\\stencils\\RectangleStencil.vue", a.render || (a.render = e.render, a.staticRenderFns = e.staticRenderFns, a._compiled = !0, o && (a.functional = !0)), a._scopeId = n, a;
}
/* style inject */

/* style inject SSR */


var RectangleStencil = __vue_normalize__$8({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, void 0, __vue_script__$8, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, void 0, void 0),
    cn$8 = easyBem("vue-circle-stencil"),
    script$9 = {
  name: "CircleStencil",
  components: {
    PreviewResult: PreviewResult,
    BoundingBox: BoundingBox,
    DraggableArea: DraggableArea
  },
  props: {
    img: {
      type: Object
    },
    stencilClass: {
      type: String
    },
    resultCoordinates: {
      type: Object
    },
    stencilCoordinates: {
      type: Object
    },
    handlers: {
      type: Object,
      "default": function _default() {
        return {
          eastNorth: !0,
          westNorth: !0,
          westSouth: !0,
          eastSouth: !0
        };
      }
    },
    handlerComponent: {
      type: [Object, String],
      "default": function _default() {
        return SimpleHandler;
      }
    },
    handlersClassnames: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    lines: {
      type: Object
    },
    lineComponent: {
      type: [Object, String],
      "default": function _default() {
        return SimpleLine;
      }
    },
    linesClassnames: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    classname: {
      type: String
    },
    previewClassname: {
      type: String
    },
    boundingBoxClassname: {
      type: String
    }
  },
  computed: {
    classes: function classes() {
      return {
        stencil: _classnames(cn$8(), this.classname),
        preview: _classnames(cn$8("preview"), this.previewClassname),
        boundingBox: _classnames(cn$8("bounding-box"), this.boundingBox)
      };
    },
    style: function style() {
      var e = this.stencilCoordinates,
          t = e.height,
          i = e.width,
          n = e.left,
          o = e.top;
      return {
        width: "".concat(i, "px"),
        height: "".concat(t, "px"),
        left: "".concat(n, "px"),
        top: "".concat(o, "px")
      };
    }
  },
  methods: {
    onMove: function onMove(e) {
      this.$emit("move", e);
    },
    onResize: function onResize(e) {
      this.$emit("resize", e);
    },
    aspectRatios: function aspectRatios() {
      return {
        minimum: 1,
        maximum: 1
      };
    }
  }
};
/* script */


var __vue_script__$9 = script$9;
/* template */

var __vue_render__$9 = function __vue_render__$9() {
  var e = this,
      t = e.$createElement,
      i = e._self._c || t;
  return i("div", {
    "class": e.classes.stencil,
    style: e.style
  }, [i("BoundingBox", {
    attrs: {
      classname: e.classes.boundingBox,
      handlers: e.handlers,
      "handler-component": e.handlerComponent,
      "handlers-classnames": e.handlersClassnames,
      lines: e.lines,
      "line-component": e.lineComponent,
      "lines-classnames": e.linesClassnames
    },
    on: {
      resize: e.onResize
    }
  }, [i("DraggableArea", {
    on: {
      move: e.onMove
    }
  }, [i("PreviewResult", {
    attrs: {
      img: e.img,
      classname: e.classes.preview,
      "result-coordinates": e.resultCoordinates,
      "stencil-coordinates": e.stencilCoordinates
    }
  })], 1)], 1)], 1);
},
    __vue_staticRenderFns__$9 = [];

__vue_render__$9._withStripped = !0;
/* style */

var __vue_inject_styles__$9 = void 0,
    __vue_scope_id__$9 = void 0,
    __vue_module_identifier__$9 = void 0,
    __vue_is_functional_template__$9 = !1;
/* scoped */

/* component normalizer */


function __vue_normalize__$9(e, t, i, n, o) {
  var a = ("function" == typeof i ? i.options : i) || {}; // For security concerns, we use only base name in production mode.

  return a.__file = "C:\\Live\\Projects\\Hot\\Vue Cropper\\vue-advanced-cropper-rollup\\src\\components\\stencils\\CircleStencil.vue", a.render || (a.render = e.render, a.staticRenderFns = e.staticRenderFns, a._compiled = !0, o && (a.functional = !0)), a._scopeId = n, a;
}
/* style inject */

/* style inject SSR */


var CircleStencil = __vue_normalize__$9({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, void 0, __vue_script__$9, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, void 0, void 0);

function getCurrentWidth(e, t, i) {
  return e.width + i * (t.left + t.right);
}

function getCurrentHeight(e, t, i) {
  return e.height + i * (t.top + t.bottom);
}

function fitConditions(e, t, i, n, o, a) {
  var s = Math.min,
      r = Math.abs,
      c = Math.floor,
      l = Math.ceil,
      h = Math.pow,
      d = i.minHeight,
      m = i.minWidth,
      p = i.maxHeight,
      g = i.maxWidth,
      u = _objectSpread({}, e),
      f = getCurrentWidth(t, u, n),
      v = getCurrentHeight(t, u, n);

  0 > f && (0 > u.left && 0 > u.right ? (u.left = -(t.width - m) / (u.left / u.right), u.right = -(t.width - m) / (u.right / u.left)) : 0 > u.left ? u.left = -(t.width - m) / n : 0 > u.right && (u.right = -(t.width - m) / n)), 0 > v && (0 > u.top && 0 > u.bottom ? (u.top = -(t.height - d) / (u.top / u.bottom), u.bottom = -(t.height - d) / (u.bottom / u.top)) : 0 > u.top ? u.top = -(t.height - d) : 0 > u.bottom && (u.bottom = -(t.height - d)));
  var w = {
    width: 1 / 0,
    height: 1 / 0
  }; // If ratio is not broken, resize all directions independently

  if (u.right + u.left && (l(t.left + t.width + n * u.right) > o.width && (w.width = s(w.width, r(c(o.width - (t.left + t.width)) / (n * u.right)))), 0 > t.left - n * u.left && (w.width = s(w.width, r(t.left / (n * u.left)))), f < m && (w.width = s(w.width, r((t.width - m) / ((u.right + u.left) * n)))), f > g && (w.width = s(w.width, r((g - t.width) / ((u.right + u.left) * n))))), u.top + u.bottom && (l(t.top + t.height + n * u.bottom) > o.height && (w.height = s(w.height, r(c(o.height - (t.top + t.height)) / (n * u.bottom)))), 0 > t.top - n * u.top && (w.height = s(w.height, r(t.top / (n * u.top)))), v < d && (w.height = s(w.height, r((t.height - d) / ((u.top + u.bottom) * n)))), v > p && (w.height = s(w.height, r((p - t.height) / ((u.top + u.bottom) * n))))), w.width < h(10, -1) && (w.width = 0), w.height < h(10, -1) && (w.height = 0), !a) w.width !== 1 / 0 && HORIZONTAL_DIRECTIONS$1.forEach(function (e) {
    u[e] *= w.width;
  }), w.height !== 1 / 0 && VERTICAL_DIRECTIONS$1.forEach(function (e) {
    u[e] *= w.height;
  });else {
    var y;
    w.height < w.width ? y = w.height : u.right + u.left && (y = w.width), (w.height !== 1 / 0 || w.width !== 1 / 0) && ALL_DIRECTIONS.forEach(function (e) {
      u[e] *= y;
    });
  }
  return u;
}

function resize(e, t, i, n, o, a) {
  var s = Math.max,
      r = Math.round,
      c = _objectSpread({}, e, {
    right: e.left + e.width,
    bottom: e.top + e.height
  }),
      l = a.params || {},
      h = _objectSpread({}, a.directions),
      d = l.allowedDirections || {
    left: !0,
    right: !0,
    bottom: !0,
    top: !0
  };

  Object.keys(d).forEach(function (e) {
    d[e] || (h[e] = 0);
  });
  var m = getCurrentWidth(c, h, n),
      p = getCurrentHeight(c, h, n);
  h = fitConditions(h, c, t, n, i), m = getCurrentWidth(c, h, n), p = getCurrentHeight(c, h, n); // Checks ratio:

  var g = null;

  if (l.preserveAspectRatio ? g = c.width / c.height : o.minimum && m / p < o.minimum ? g = o.minimum : o.maximum && m / p > o.maximum && (g = o.maximum), g) {
    var u = l.respectDirection;

    if (u || (c.width > c.height ? u = "width" : u = "height"), "width" === u) {
      var f = c.height - m / g;
      d.top && d.bottom ? (h.bottom = -f / (2 * n), h.top = -f / (2 * n)) : d.top ? h.top = -f / n : d.bottom ? h.bottom = -f / n : d.right ? h.right = 0 : d.left && (h.left = 0);
    } else if ("height" === u) {
      var v = c.width - p * g;
      d.left && d.right ? (h.left = -v / (2 * n), h.right = -v / (2 * n)) : d.left ? h.left = -v / n : d.right ? h.right = -v / n : d.top ? h.top = 0 : d.bottom && (h.bottom = 0);
    } else ALL_DIRECTIONS.forEach(function (e) {
      h[e] *= 0;
    });
  } // 3. Third step: check if desired box with correct aspect ratios break some limits and fit to this conditions


  return h = fitConditions(h, c, t, n, i, g), {
    width: e.width + n * (r(h.right) + r(h.left)),
    height: e.height + n * (r(h.top) + r(h.bottom)),
    left: s(0, e.left - n * r(h.left)),
    top: s(0, e.top - n * r(h.top))
  };
}

function move(e, t, i, n) {
  var o = Math.max,
      a = _objectSpread({}, n.directions),
      s = {
    left: e.left + i * a.left,
    top: e.top + i * a.top,
    width: e.width,
    height: e.height
  };

  return 0 > s.left && (s.left = 0), s.left + s.width > t.width && (s.left = o(0, t.width - s.width)), 0 > s.top && (s.top = 0), s.top + s.height > t.height && (s.top = o(0, t.height - s.height)), s;
}

function areaSize(e, t, i, n) {
  var o = e.clientHeight,
      a = e.clientWidth,
      s = o,
      r = i * o / n;
  return r > a && (r = a, s = n * a / i), {
    width: r,
    height: s
  };
} // eslint-disable-next-line no-unused-vars


function defaultPosition(e, t, i, n, o, a) {
  return {
    left: o / 2 - i / 2,
    top: a / 2 - n / 2
  };
} // eslint-disable-next-line no-unused-vars


function defaultSize(e, t, i) {
  var o,
      a,
      n = Math.max,
      s = i.maxWidth,
      r = i.maxHeight,
      c = i.minWidth,
      l = i.minHeight;
  return r > s ? (o = n(l, .8 * r), a = n(c, .8 * s)) : (a = n(c, .8 * s), o = n(l, .8 * r)), {
    height: o,
    width: a
  };
}

function percentRestrictions(e, t, i, n, o, a) {
  return {
    minWidth: e / 100 * o,
    minHeight: t / 100 * a,
    maxWidth: i ? i / 100 * o : o,
    maxHeight: n ? n / 100 * a : a
  };
}

var cn$9 = easyBem("vue-advanced-cropper"),
    script$a = {
  name: "Cropper",
  props: {
    src: {
      type: String,
      "default": null
    },
    resizeAlgorithm: {
      type: Function,
      "default": resize
    },
    moveAlgorithm: {
      type: Function,
      "default": move
    },
    defaultSize: {
      type: Function,
      "default": defaultSize
    },
    defaultPosition: {
      type: Function,
      "default": defaultPosition
    },
    areaSize: {
      type: Function,
      "default": areaSize
    },
    restrictions: {
      type: Function,
      "default": percentRestrictions
    },
    minWidth: {
      type: [Number, String],
      "default": 10
    },
    minHeight: {
      type: [Number, String],
      "default": 10
    },
    maxWidth: {
      type: [Number, String]
    },
    maxHeight: {
      type: [Number, String]
    },
    stencilComponent: {
      type: [Object, String],
      "default": function _default() {
        return RectangleStencil;
      }
    },
    stencilProps: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    classname: {
      type: String
    },
    imageClassname: {
      type: String
    },
    areaClassname: {
      type: String
    },
    backgroundClassname: {
      type: String
    },
    debounce: {
      type: Number,
      "default": 500
    },
    canvas: {
      type: Boolean,
      "default": !0
    },
    checkCrossOrigin: {
      type: Boolean,
      "default": !0
    },
    checkOrientation: {
      type: Boolean,
      "default": !0
    },
    transitionTime: {
      type: Number,
      "default": 300
    }
  },
  data: function data() {
    return {
      boundarySize: {
        width: null,
        height: null
      },
      imageLoaded: !1,
      imageAttributes: {
        crossOrigin: !1,
        src: null
      },
      imageTransforms: {
        rotate: null,
        scaleX: null,
        scaleY: null
      },
      imageSize: {
        width: null,
        height: null
      },
      coordinates: {
        left: 0,
        top: 0,
        width: 0,
        height: 0
      },
      frozenDirections: {
        width: !1,
        height: !1
      }
    };
  },
  computed: {
    coefficient: function coefficient() {
      return this.imageSize.width ? this.imageSize.width / this.boundarySize.width : 0;
    },
    classes: function classes() {
      return {
        cropper: _classnames(cn$9(), this.classname),
        image: _classnames(cn$9("image"), this.imageClassname),
        area: _classnames(cn$9("area"), this.areaClassname),
        stretcher: _classnames(cn$9("stretcher")),
        background: _classnames(cn$9("background"), this.backgroundClassname)
      };
    },
    stencilCoordinates: function stencilCoordinates() {
      var e = this.coordinates,
          t = e.width,
          i = e.height,
          n = e.left,
          o = e.top;
      return {
        width: t / this.coefficient,
        height: i / this.coefficient,
        left: n / this.coefficient,
        top: o / this.coefficient
      };
    },
    wrapperStyle: function wrapperStyle() {
      return {
        width: "".concat(this.stencilCoordinates.width, "px"),
        height: "".concat(this.stencilCoordinates.height, "px"),
        left: "".concat(this.stencilCoordinates.left, "px"),
        top: "".concat(this.stencilCoordinates.top, "px")
      };
    },
    areaStyle: function areaStyle() {
      return {
        width: this.boundarySize.width ? "".concat(this.boundarySize.width, "px") : "auto",
        height: this.boundarySize.height ? "".concat(this.boundarySize.height, "px") : "auto",
        opacity: this.imageLoaded ? 1 : 0,
        transition: "opacity ".concat(this.transitionTime, "ms")
      };
    },
    imageStyle: function imageStyle() {
      var e = {
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)" + getStyleTransforms(this.imageTransforms)
      },
          t = this.imageTransforms.flipped;
      return t ? (e.width = "".concat(this.boundarySize.height, "px"), e.height = "".concat(this.boundarySize.width, "px")) : (e.width = "".concat(this.boundarySize.width, "px"), e.height = "".concat(this.boundarySize.height, "px")), e;
    },
    stencilRestrictions: function stencilRestrictions() {
      var e = this.restrictions(+this.minWidth, +this.minHeight, +this.maxWidth, +this.maxHeight, this.imageSize.width, this.imageSize.height);
      return this.minWidth > this.imageSize.width && (console.warn("Warning: minimum width (".concat(e.minWidth, "px) greater that the image width (").concat(this.imageSize.width, "px). It is set equal to the image width and width resizing was blocked")), e.minWidth = this.imageSize.width, e.widthFrozen = !0), this.minHeight > this.imageSize.height && (console.warn("Warning: minimum height (".concat(e.minHeight, "px) greater that the image height (").concat(this.imageSize.height, "px). It is set equal to the image height and height resizing was blocked")), e.minHeight = this.imageSize.height, e.heightFrozen = !0), e.minWidth > e.maxWidth && (console.warn("Warning: maximum width (".concat(e.maxWidth, "px) fewer that the minimum width (").concat(e.minWidth, "px). It is set equal to the minimum width and width resizing was blocked")), e.maxWidth = e.minWidth, e.widthFrozen = !0), e.minHeight > e.maxHeight && (console.warn("Warning: maximum height (".concat(e.maxHeight, "px) fewer that the minimum height (").concat(e.minHeight, "px). It is set equal to the minimum height and height resizing was blocked")), e.maxHeight = e.minHeight, e.heightFrozen = !0), (!e.maxWidth || e.maxWidth > this.imageSize.width) && (e.maxWidth = this.imageSize.width), (!e.maxHeight || e.maxHeight > this.imageSize.height) && (e.maxHeight = this.imageSize.height), e;
    }
  },
  watch: {
    src: function src() {
      var e = this;
      Vue.nextTick(function () {
        e.onChangeImage();
      });
    },
    minWidth: function minWidth() {
      this.resetCoordinates();
    },
    maxWidth: function maxWidth() {
      this.resetCoordinates();
    },
    minHeight: function minHeight() {
      this.resetCoordinates();
    },
    maxHeight: function maxHeight() {
      this.resetCoordinates();
    }
  },
  mounted: function mounted() {
    var e = this;
    this.debouncedUpdate = debounce_1(this.update, this.debounce), window.addEventListener("resize", this.refreshImage), window.addEventListener("orientationchange", this.refreshImage), this.$refs.image.addEventListener("load", function () {
      e.$refs.image && e.refreshImage().then(e.resetCoordinates);
    }), this.onChangeImage();
  },
  destroyed: function destroyed() {
    window.removeEventListener("resize", this.refreshImage), window.removeEventListener("orientationchange", this.refreshImage);
  },
  methods: {
    // External methods
    getResult: function getResult() {
      return this.canvas && this.src ? (this.updateCanvas(this.coordinates), {
        coordinates: _objectSpread({}, this.coordinates),
        canvas: this.$refs.canvas
      }) : {
        coordinates: _objectSpread({}, this.coordinates)
      };
    },
    // Internal methods
    getArea: function getArea() {
      return this.$refs.area;
    },
    getStencil: function getStencil() {
      return this.$refs.stencil;
    },
    updateCanvas: function updateCanvas(e) {
      // This function can be asynchronously called because it's debounced
      // Therefore there is workaround to prevent processing after the component was unmounted
      if (this.$refs.canvas) {
        var t = this.$refs.image,
            i = this.checkOrientation ? prepareSource(this.$refs.sourceCanvas, t, this.imageTransforms) : t,
            n = this.$refs.canvas;
        n.width = e.width, n.height = e.height;
        var o = n.getContext("2d");
        o.drawImage(i, e.left, e.top, e.width, e.height, 0, 0, e.width, e.height);
      }
    },
    update: function update() {
      this.$emit("change", this.getResult());
    },
    onChangeCoordinates: function onChangeCoordinates(e) {
      var t = !(1 < arguments.length && arguments[1] !== void 0) || arguments[1];
      this.coordinates = e, this.$listeners && this.$listeners.change && (t ? this.debouncedUpdate() : this.update());
    },
    onChangeImage: function onChangeImage() {
      var e = this;

      if (this.imageLoaded = !1, this.src) {
        var t = isCrossOriginURL(this.src);
        t && this.canvas && this.checkCrossOrigin && (this.imageAttributes.crossOrigin = "anonymous"), setTimeout(function () {
          e.checkOrientation ? parseImage(t ? addTimestamp(e.src) : e.src).then(e.onParseImage) : e.onParseImage({});
        }, this.transitionTime);
      } else this.onChangeCoordinates({
        left: 0,
        top: 0,
        width: 0,
        height: 0
      }, !1);
    },
    onParseImage: function onParseImage(e) {
      var t = this,
          i = e.arrayBuffer,
          n = e.orientation;
      this.imageAttributes.src = i && n && isLocal(this.src) ? arrayBufferToDataURL(i) : this.src, this.imageTransforms = getImageTransforms(n), Vue.nextTick(function () {
        var e = t.$refs.image;
        e && e.complete && t.refreshImage().then(t.resetCoordinates);
      });
    },
    onResize: function onResize(e) {
      this.frozenDirections.width && (e.directions.left = 0, e.directions.right = 0), this.frozenDirections.height && (e.directions.top = 0, e.directions.bottom = 0), this.onChangeCoordinates(this.resizeAlgorithm(this.coordinates, this.stencilRestrictions, this.imageSize, this.coefficient, this.stencilAspectRatios(), e));
    },
    onMove: function onMove(e) {
      this.onChangeCoordinates(this.moveAlgorithm(this.coordinates, this.imageSize, this.coefficient, e));
    },
    defaultCoordinates: function defaultCoordinates() {
      var e = Math.max,
          t = Math.min,
          i = this.stencilAspectRatios(),
          n = this.stencilRestrictions,
          o = n.minWidth,
          a = n.minHeight,
          s = n.maxWidth,
          r = n.maxHeight,
          c = this.imageSize,
          l = {};
      if (!i.minimum && !i.maximum) l.height = a, l.width = o;else {
        var h = {
          width: {
            maximum: i.minimum ? t(r, o / i.minimum) : r,
            minimum: i.maximum ? e(a, o / i.maximum) : a
          },
          height: {
            maximum: i.maximum ? t(s, a * i.maximum) : s,
            minimum: i.mininum ? e(o, a * i.mininum) : o
          }
        };
        if (h.width.maximum >= h.width.minimum) l.width = o, l.height = h.width.minimum;else if (h.height.maximum >= h.height.minimum) l.height = a, l.width = h.height.minimum;else throw "Error: current aspect ratio is incompatible with minimum/maximum height and width settings. Can't setup default coordinates";
      }
      return l.left = c.width / 2 - l.width / 2, l.top = c.height / 2 - l.height / 2, l;
    },
    setCoordinates: function setCoordinates(e) {
      var t = this,
          i = this.imageSize,
          n = this.coefficient,
          o = this.stencilAspectRatios(),
          a = function a(e, o) {
        return t.moveAlgorithm(e, i, n, new MoveEvent(null, {
          left: (o.left - e.left) / n,
          top: (o.top - e.top) / n
        }));
      },
          s = function s(e, _s) {
        var r = t.defaultCoordinates();
        return r = t.resizeAlgorithm(r, t.stencilRestrictions, i, n, o, new ResizeEvent(null, {
          left: (_s.width - r.width) / (2 * n),
          right: (_s.width - r.width) / (2 * n),
          top: (_s.height - r.height) / (2 * n),
          bottom: (_s.height - r.height) / (2 * n)
        })), a(r, {
          left: e.left,
          top: e.top
        });
      },
          r = this.coordinates;

      return e.forEach || (e = [e]), e.forEach(function (e) {
        var i = {};
        i = "function" == typeof e ? e(_objectSpread({}, r), t.imageSize) : e, (i.width || i.height) && (r = s(r, _objectSpread({}, r, i))), (i.left || i.top) && (r = a(r, _objectSpread({}, r, i)));
      }), this.onChangeCoordinates(r, !1), r;
    },
    resetCoordinates: function resetCoordinates() {
      var e = this; // This function can be asynchronously called after completion of refreshing image promise
      // Therefore there is a workaround to prevent processing after the component was unmounted

      if (this.$refs.image) {
        var t = this.$refs.cropper,
            i = this.$refs.image,
            n = this.stencilRestrictions,
            o = n.minWidth,
            a = n.minHeight,
            s = n.maxWidth,
            r = n.maxHeight,
            c = n.widthFrozen,
            l = n.heightFrozen;
        this.frozenDirections.width = !!c, this.frozenDirections.height = !!l;
        var h = this.defaultSize(t, i, this.stencilRestrictions, this.imageSize.width, this.imageSize.height, this.$props);
        (h.width < o || h.height < a || h.width > s || h.height > r) && console.warn("Warning: default size breaking size restrictions. Check your defaultSize function"), this.setCoordinates([h, function (n) {
          return _objectSpread({}, e.defaultPosition(t, i, n.width, n.height, e.imageSize.width, e.imageSize.height, e.$props));
        }]), this.imageLoaded = !0;
      }
    },
    refreshImage: function refreshImage() {
      var e = this,
          t = this.$refs.image,
          i = this.$refs.stretcher;
      this.imageTransforms.flipped ? (this.imageSize.height = t.naturalWidth, this.imageSize.width = t.naturalHeight) : (this.imageSize.height = t.naturalHeight, this.imageSize.width = t.naturalWidth);
      var n = this.imageSize.width / this.imageSize.height;
      return this.imageSize.height > this.imageSize.width ? (i.style.height = "".concat(this.imageSize.height, "px"), i.style.width = "".concat(i.clientHeight * n, "px"), i.clientWidth / i.clientHeight != n && (i.style.height = "".concat(i.clientWidth / n, "px"))) : (i.style.width = "".concat(this.imageSize.width, "px"), i.style.height = "".concat(i.clientWidth / n, "px"), i.clientHeight / i.clientWidth != n && (i.style.width = "".concat(i.clientHeight * n, "px"))), new Promise(function (t) {
        var i = e.$refs.cropper,
            n = e.$refs.image;
        Vue.nextTick(function () {
          var o = e.areaSize(i, n, e.imageSize.width, e.imageSize.height),
              a = o.height,
              s = o.width;
          a && (e.boundarySize.height = a), s && (e.boundarySize.width = s), t();
        });
      });
    },
    stencilAspectRatios: function stencilAspectRatios() {
      return this.$refs.stencil.aspectRatios ? this.$refs.stencil.aspectRatios() : {
        minimum: this.stencilProps.aspectRatio || this.stencilProps.minAspectRatio,
        maximum: this.stencilProps.aspectRatio || this.stencilProps.maxAspectRatio
      };
    }
  }
};
/* script */

var __vue_script__$a = script$a;
/* template */

var __vue_render__$a = function __vue_render__$a() {
  var e = this,
      t = e.$createElement,
      i = e._self._c || t;
  return i("div", {
    ref: "cropper",
    "class": e.classes.cropper
  }, [i("div", {
    "class": e.classes.background,
    style: e.areaStyle
  }), e._v(" "), i("div", {
    ref: "stretcher",
    "class": e.classes.stretcher
  }), e._v(" "), i("div", {
    ref: "area",
    "class": e.classes.area,
    style: e.areaStyle
  }, [i("img", {
    ref: "image",
    "class": e.classes.image,
    style: e.imageStyle,
    attrs: {
      crossOrigin: e.imageAttributes.crossOrigin,
      src: e.imageAttributes.src
    }
  }), e._v(" "), i(e.stencilComponent, e._b({
    ref: "stencil",
    tag: "component",
    attrs: {
      img: {
        src: e.imageAttributes.src,
        size: e.imageSize,
        transforms: e.imageTransforms
      },
      "result-coordinates": e.coordinates,
      "stencil-coordinates": e.stencilCoordinates
    },
    on: {
      resize: e.onResize,
      move: e.onMove
    }
  }, "component", e.stencilProps, !1)), e._v(" "), e.canvas ? i("canvas", {
    ref: "canvas",
    style: {
      display: "none"
    }
  }) : e._e(), e._v(" "), e.canvas ? i("canvas", {
    ref: "sourceCanvas",
    style: {
      display: "none"
    }
  }) : e._e()], 1)]);
},
    __vue_staticRenderFns__$a = [];

__vue_render__$a._withStripped = !0;
/* style */

var __vue_inject_styles__$a = void 0,
    __vue_scope_id__$a = void 0,
    __vue_module_identifier__$a = void 0,
    __vue_is_functional_template__$a = !1;
/* scoped */

/* component normalizer */


function __vue_normalize__$a(e, t, i, n, o) {
  var a = ("function" == typeof i ? i.options : i) || {}; // For security concerns, we use only base name in production mode.

  return a.__file = "C:\\Live\\Projects\\Hot\\Vue Cropper\\vue-advanced-cropper-rollup\\src\\Cropper.vue", a.render || (a.render = e.render, a.staticRenderFns = e.staticRenderFns, a._compiled = !0, o && (a.functional = !0)), a._scopeId = n, a;
}
/* style inject */

/* style inject SSR */


var Cropper = __vue_normalize__$a({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, void 0, __vue_script__$a, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, void 0, void 0),
    cn$a = easyBem("vue-preview-image"),
    script$b = {
  name: "PreviewImage",
  props: {
    img: {
      type: String
    },
    classname: {
      type: String
    },
    imageClassname: {
      type: String
    },
    width: {
      type: Number
    },
    height: {
      type: Number
    },
    top: {
      type: Number
    },
    left: {
      type: Number
    },
    previewWidth: {
      type: Number,
      required: !0
    },
    previewHeight: {
      type: Number,
      required: !0
    }
  },
  data: function data() {
    return {
      imageSize: {
        width: 0,
        height: 0
      }
    };
  },
  computed: {
    classnames: function classnames() {
      return {
        "default": _classnames(cn$a(), this.classname),
        image: _classnames(cn$a("image"), this.imageClassname)
      };
    },
    wrapperStyle: function wrapperStyle() {
      return {
        width: "".concat(this.previewWidth, "px"),
        height: "".concat(this.previewHeight, "px")
      };
    },
    imageStyle: function imageStyle() {
      var e = this.previewHeight / this.height,
          t = this.imageSize.height * e,
          i = this.imageSize.width * e;
      return {
        width: "".concat(i, "px"),
        height: "".concat(t, "px"),
        left: "".concat(-this.left * e, "px"),
        top: "".concat(-this.top * e, "px")
      };
    }
  },
  watch: {
    img: function img() {
      this.onChangeImage();
    }
  },
  mounted: function mounted() {
    this.onChangeImage();
  },
  methods: {
    refreshImage: function refreshImage() {
      var e = this.$refs.image;
      this.imageSize.height = e.naturalHeight, this.imageSize.width = e.naturalWidth;
    },
    onChangeImage: function onChangeImage() {
      var e = this,
          t = this.$refs.image;
      t.complete ? this.refreshImage() : t.addEventListener("load", function () {
        e.refreshImage();
      });
    }
  }
};
/* script */


var __vue_script__$b = script$b;
/* template */

var __vue_render__$b = function __vue_render__$b() {
  var e = this,
      t = e.$createElement,
      i = e._self._c || t;
  return i("div", {
    "class": e.classnames["default"],
    style: e.wrapperStyle
  }, [i("img", {
    ref: "image",
    "class": e.classnames.image,
    style: e.imageStyle,
    attrs: {
      src: e.img
    }
  })]);
},
    __vue_staticRenderFns__$b = [];

__vue_render__$b._withStripped = !0;
/* style */

var __vue_inject_styles__$b = void 0,
    __vue_scope_id__$b = void 0,
    __vue_module_identifier__$b = void 0,
    __vue_is_functional_template__$b = !1;
/* scoped */

/* component normalizer */


function __vue_normalize__$b(e, t, i, n, o) {
  var a = ("function" == typeof i ? i.options : i) || {}; // For security concerns, we use only base name in production mode.

  return a.__file = "C:\\Live\\Projects\\Hot\\Vue Cropper\\vue-advanced-cropper-rollup\\src\\components\\helpers\\PreviewImage.vue", a.render || (a.render = e.render, a.staticRenderFns = e.staticRenderFns, a._compiled = !0, o && (a.functional = !0)), a._scopeId = n, a;
}
/* style inject */

/* style inject SSR */


var PreviewImage = __vue_normalize__$b({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, void 0, __vue_script__$b, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, void 0, void 0);

Vue.component("cropper", Cropper), Vue.component("rectangle-stencil", RectangleStencil), Vue.component("circle-stencil", CircleStencil), Vue.component("simple-handler", SimpleHandler), Vue.component("simple-line", SimpleLine);
export { BoundingBox, CircleStencil, Cropper, DragEvent, DraggableArea, DraggableElement, HandlerWrapper, LineWrapper, MoveEvent, PreviewImage, PreviewResult, RectangleStencil, ResizeEvent, SimpleHandler, SimpleLine };

function styleInject(id, css) {
  if (!css || typeof document === 'undefined') {
    return;
  }

  var element;
  var head = document.head || document.getElementsByTagName('head')[0];
  var styleElements = head.getElementsByTagName('style'); // To prevent dublicate of the style code during the script reload

  for (var i = 0; i < styleElements.length; i++) {
    if (styleElements[i] && styleElements[i].innerText && styleElements[i].innerText.startsWith('/*for=' + id)) {
      element = styleElements[i];
    }
  }

  if (!element) {
    element = document.createElement('style');
    element.type = 'text/css';
    head.insertBefore(element, styleElements[0] || head.firstChild);
  }

  if (element.styleSheet) {
    element.styleSheet.cssText = css;
  } else {
    var text = document.createTextNode('/*for=' + id + '*/' + css);
    element.innerHTML = "";
    element.appendChild(text);
  }
}

;
styleInject("vue-advanced-cropper", ".vue-advanced-cropper {  text-align: center;  position: relative;  overflow: hidden;  -webkit-user-select: none;     -moz-user-select: none;      -ms-user-select: none;          user-select: none;  max-height: 100%;  max-width: 100%;}.vue-advanced-cropper__stretcher {    pointer-events: none;    position: relative;    max-width: 100%;    max-height: 100%;}.vue-advanced-cropper__image {    opacity: 0.5;    -webkit-user-select: none;       -moz-user-select: none;        -ms-user-select: none;            user-select: none;    position: absolute;    -webkit-transform-origin: center;            transform-origin: center;    max-width: unset !important;}.vue-advanced-cropper__area {    position: absolute;    left: 50%;    -webkit-transform: translate(-50%, -50%);            transform: translate(-50%, -50%);    top: 50%;}.vue-advanced-cropper__background {    position: absolute;    background: black;    top: 50%;    left: 50%;    -webkit-transform: translate(-50%, -50%);            transform: translate(-50%, -50%);}.vue-advanced-cropper__stencil-wrapper {    position: absolute;}/*# sourceMappingURL=Cropper.vue.map */.vue-line-wrapper {  background: none;  position: absolute;  display: -webkit-box;  display: -ms-flexbox;  display: flex;  -webkit-box-align: center;      -ms-flex-align: center;          align-items: center;  -webkit-box-pack: center;      -ms-flex-pack: center;          justify-content: center;}.vue-line-wrapper--north, .vue-line-wrapper--south {    height: 12px;    width: 100%;    left: 0;    -webkit-transform: translateY(-50%);            transform: translateY(-50%);}.vue-line-wrapper--north {    top: 0;    cursor: n-resize;}.vue-line-wrapper--south {    top: 100%;    cursor: s-resize;}.vue-line-wrapper--east, .vue-line-wrapper--west {    width: 12px;    height: 100%;    -webkit-transform: translateX(-50%);            transform: translateX(-50%);    top: 0;}.vue-line-wrapper--east {    left: 100%;    cursor: e-resize;}.vue-line-wrapper--west {    left: 0;    cursor: w-resize;}/*# sourceMappingURL=LineWrapper.vue.map */.vue-handler-wrapper {  position: absolute;  -webkit-transform: translate(-50%, -50%);          transform: translate(-50%, -50%);}.vue-handler-wrapper__draggable {    width: 30px;    height: 30px;    display: -webkit-box;    display: -ms-flexbox;    display: flex;    -webkit-box-align: center;        -ms-flex-align: center;            align-items: center;    -webkit-box-pack: center;        -ms-flex-pack: center;            justify-content: center;}.vue-handler-wrapper--west-north {    left: 0;    top: 0;    cursor: nw-resize;}.vue-handler-wrapper--north {    left: 50%;    top: 0;    cursor: n-resize;}.vue-handler-wrapper--east-north {    left: 100%;    top: 0;    cursor: ne-resize;}.vue-handler-wrapper--east {    left: 100%;    top: 50%;    cursor: e-resize;}.vue-handler-wrapper--east-south {    left: 100%;    top: 100%;    cursor: se-resize;}.vue-handler-wrapper--south {    left: 50%;    top: 100%;    cursor: s-resize;}.vue-handler-wrapper--west-south {    left: 0;    top: 100%;    cursor: sw-resize;}.vue-handler-wrapper--west {    left: 0;    top: 50%;    cursor: w-resize;}/*# sourceMappingURL=HandlerWrapper.vue.map */.vue-bounding-box {  position: relative;  height: 100%;  width: 100%;}.vue-bounding-box__line {    position: absolute;}.vue-bounding-box__line--north {      top: 0;      width: 100%;      cursor: n-resize;}.vue-bounding-box__line--east {      left: 100%;      top: 0;      height: 100%;      cursor: e-resize;}.vue-bounding-box__line--south {      top: 100%;      width: 100%;      cursor: s-resize;}.vue-bounding-box__line--west {      left: 0;      top: 0;      height: 100%;      cursor: w-resize;}/*# sourceMappingURL=BoundingBox.vue.map */.vue-preview-result {  overflow: hidden;  -webkit-box-sizing: border-box;          box-sizing: border-box;  position: absolute;  height: 100%;  width: 100%;}.vue-preview-result__wrapper {    position: absolute;}.vue-preview-result__image {    pointer-events: none;    position: absolute;    -webkit-user-select: none;       -moz-user-select: none;        -ms-user-select: none;            user-select: none;    -webkit-transform-origin: center;            transform-origin: center;    max-width: unset !important;}/*# sourceMappingURL=PreviewResult.vue.map */.vue-draggable-area {  position: relative;}/*# sourceMappingURL=DraggableArea.vue.map */.vue-square-handler {  display: block;  background: white;  height: 10px;  width: 10px;}/*# sourceMappingURL=SimpleHandler.vue.map */.vue-simple-line {  background: none;  -webkit-transition: border 0.5s;  transition: border 0.5s;  border-color: rgba(255, 255, 255, 0.3);  border-width: 0;  border-style: solid;}.vue-simple-line--south, .vue-simple-line--north {    height: 0;    width: 100%;}.vue-simple-line--east, .vue-simple-line--west {    height: 100%;    width: 0;}.vue-simple-line--east {    border-right-width: 1px;}.vue-simple-line--west {    border-left-width: 1px;}.vue-simple-line--south {    border-top-width: 1px;}.vue-simple-line--north {    border-bottom-width: 1px;}.vue-simple-line--hover {    opacity: 1;    border-color: white;}/*# sourceMappingURL=SimpleLine.vue.map */.vue-circle-stencil {  position: absolute;  height: 100%;  width: 100%;  -webkit-box-sizing: content-box;          box-sizing: content-box;  cursor: move;}.vue-circle-stencil__preview {    border-radius: 50%;}/*# sourceMappingURL=CircleStencil.vue.map */.vue-rectangle-stencil {  position: absolute;  height: 100%;  width: 100%;  -webkit-box-sizing: border-box;          box-sizing: border-box;  cursor: move;}/*# sourceMappingURL=RectangleStencil.vue.map */.vue-preview-image {  overflow: hidden;  position: relative;}.vue-preview-image__image {    pointer-events: none;    position: absolute;    max-width: unset !important;}/*# sourceMappingURL=PreviewImage.vue.map */");